// @flow
import React from 'react'
import { Link } from 'react-scroll'
import renderHTML from 'react-render-html'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'

const isMobile = browserCheck.isMobile
const scrollSpeed = 20
const scrollOffset = -47
export class SectionOverview extends React.Component<Props, State> {
  constructor() {
    super()
    this.handleClick = this.handleClick.bind(this)
    this.calculateScrollDuration = this.calculateScrollDuration.bind(this)
  }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  handleClick() {
    // console.log('handleClick')
    this.props.closeMenu()
  }

  calculateScrollDuration(targetElement) {
    // console.log('calculateScrollDuration')
    // console.log('targetElement: ', targetElement)

    // track in google analytics
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: `overview-menu: ` + targetElement
    })

    const scrollTarget = document.getElementById(targetElement)
    const rect = scrollTarget.getBoundingClientRect()
    const parentRect = document.documentElement.getBoundingClientRect()
    const scrollY = document.documentElement.scrollTop
    const targetY = rect.top - parentRect.top
    const scrollDistance =
      targetY >= scrollY
        ? targetY - scrollY + scrollOffset
        : scrollY - targetY - scrollOffset
    const scrollDuration = scrollDistance / scrollSpeed
    /*
    console.log('scrollY:', scrollY)
    console.log('targetY:', targetY)
    console.log('scrollOffset:', scrollOffset)
    console.log('scrollDistance:', scrollDistance)
    console.log('scrollDuration:', scrollDuration)
    */
    return scrollDuration > 750
      ? scrollDuration < 3000
        ? scrollDuration
        : 3000 // max duration = 3000
      : 750 // min duration = 500
  }

  render() {
    // console.log('overview')
    let subchapters = 1
    let prevSubchapters = 0
    const overviewData = this.props.menuData.slice(1) // exclude first element (prologue)
    const output = overviewData.map(
      function(chapter, i) {
        prevSubchapters = subchapters
        if (chapter.subchapters != null) {
          subchapters += chapter.subchapters.length
        }
        return (
          <div className='item'>
            <Link
              className='nav-link header'
              to={'section-' + (i + 2)} // 2: since prologue is excluded
              spy
              smooth
              duration={function(scrollDistanceInPx) {
                const duration = this.calculateScrollDuration(
                  'section-' + (i + 1)
                )
                // console.log('duration:', duration)
                return duration
              }.bind(this)}
              offset={0}
              isDynamic
              onClick={this.handleClick}
              smooth='easeInOutCirc'
            >
              <i className='angle double down icon' />
              <div className='content'>
                {renderHTML(chapter.title)}
                {chapter.subchapters != null && (
                  <div className='description'>
                    Kapitel {prevSubchapters} bis {subchapters - 1}
                  </div>
                )}
              </div>
            </Link>
          </div>
        )
      }.bind(this)
    )

    return (
      <div className='section-overview'>
        <h5>Inhalt</h5>
        <div className='ui very relaxed divided list'>{output}</div>
      </div>
    )
  }
}
